import { useTranslation } from 'react-i18next';

import { ReactComponent as TimeIcon } from '../../assets/icons/timer-icon.svg';
import CustomInput from '../custom-input/CustomInput';

interface CustomInputProperties {
  inputLabel?: string;
  onChangeValue: (name: string, value: string | number) => void;
  valueRequired?: boolean;
  readOnly?: boolean;
  hourValue: string;
  minutesValue: string;
  error?: boolean;
  errorMessage?: string;
}

/**
 * File upload input box
 */
function CustomHoursLimit({
  inputLabel,
  onChangeValue,
  valueRequired,
  hourValue,
  minutesValue,
  readOnly,
  error,
  errorMessage,
}: CustomInputProperties) {
  const { t, i18n } = useTranslation('sharedComp');

  return (
    <div className="custom-hours-limit-wrap" dir={i18n.dir()}>
      {inputLabel && (
        <p className={`input-label ${error && 'error'}`}>
          {inputLabel}
          {valueRequired && <span>*</span>}
        </p>
      )}
      <div className="custom-hours-limit">
        <CustomInput
          name="hour"
          placeholder=""
          onChangeValue={onChangeValue}
          type="text"
          value={hourValue}
          frondIcon={<TimeIcon />}
          svgIcon={<p className="grey-text">{t('hrs')}</p>}
          readOnly={readOnly}
        />
        <CustomInput
          name="minutes"
          placeholder=""
          onChangeValue={onChangeValue}
          type="text"
          frondIcon={<TimeIcon />}
          svgIcon={<p className="grey-text">{t('min')}</p>}
          value={minutesValue}
        />
        <p>{t('perDay')}</p>
      </div>
      {error && <p className="custom-input-error-message">{errorMessage}</p>}
    </div>
  );
}

CustomHoursLimit.defaultProps = {
  inputLabel: '',
  valueRequired: false,
  readOnly: false,
  error: false,
  errorMessage: '',
};

export default CustomHoursLimit;
